import type { AxiosResponse } from 'axios';
import { ImResponse, leyanbotClient } from 'services/api';

// A successful HTTP response can still contain a Mapping business conflict.
const unwrapKnowledge = async <T>(request: Promise<AxiosResponse<ImResponse<T>>>) => {
  const response = await request;
  if (![0, 200].includes(Number(response.data.code))) {
    throw Object.assign(new Error('Knowledge request failed'), {
      code: response.data.code,
      response,
    });
  }
  return response.data.data;
};

export const knowledgeGet = <T>(path: string, params?: unknown) =>
  unwrapKnowledge(leyanbotClient.get<ImResponse<T>>(path, { params }));
export const knowledgePost = <T>(path: string, body?: unknown) =>
  unwrapKnowledge(leyanbotClient.post<ImResponse<T>>(path, body));
export const knowledgePut = <T>(path: string, body?: unknown) =>
  unwrapKnowledge(leyanbotClient.put<ImResponse<T>>(path, body));
